module.exports = __webpack_public_path__ + "img/img35.af62c188.svg";